import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faXmark } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import Cookies from "js-cookie";

import Purple_border_btn from "../../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import { luxuryCategory } from "../../../../utils/luxuryapis/Home/Homeapi";
import { getBespokeProgress, postBespokeStep2 } from "../../../../utils/apis/BespokeGift/bespoke_gift";
import { Select2Data } from "../../../../utils/api";
import { occasion, preferedPackaging } from "../../../../utils/apis/Home/Homeapi";
import { Website_Type } from "../../../../utils/common";

const PACKAGING_OPTIONS = ["Wooden Box", "Eco-Wrap", "Luxury Paper"];

const OCCASION_OPTIONS = [
  { value: "Birthday", label: "Birthday" },
  { value: "Anniversary", label: "Anniversary" },
  { value: "Wedding", label: "Wedding" },
  { value: "Corporate", label: "Corporate" },
  { value: "Festive", label: "Festive" },
  { value: "Other", label: "Other" },
];

function Step_2({ handleNext, draftId, handleBack }) {
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [occasionOptions, setOccasionOptions] = useState([]);
  const [packagingOptions, setPackagingOptions] = useState([]);
  const [addOnInput, setAddOnInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  // ── useForm — mirrors Step 1 pattern exactly ──────────────────────────────
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      gift_category_id: "",
      occasion: "",
      budget: 15000,
      quantity: "",
      packaging: "",
      add_ons: "",
    },
  });

  const budget = watch("budget");
  const packaging = watch("packaging_pref_id");

  const getAllCategories = async () => {
    try {
      const res = await luxuryCategory();
      if (res?.success) {
        setCategoryOptions(await Select2Data(res?.data, "gift_category_id") || []);

      } else {
        console.error("Error fetching categories:", res?.error);
      }
    } catch (error) {
      console.error(error);
    }
  };


  const getAllOccation = async () => {
    try {
      const res = await occasion(Website_Type.Luxury);
      if (res?.success) {
        setOccasionOptions(await Select2Data(res?.data, "occasion_id") || []);

      } else {
        console.error("Error fetching occation:", res?.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getAllPackagin = async () => {
    try {
      const res = await preferedPackaging();
      if (res?.success) {
        setPackagingOptions(res?.data || []);

      } else {
        console.error("Error fetching packagin:", res?.error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllOccation();
    getAllPackagin();
  }, []);

  useEffect(() => {
    const draftId = Cookies.get("draftId");
    if (!draftId) return;

    const fetchDraft = async () => {
      try {
        const res = await getBespokeProgress(draftId);
        if (res?.success) {
          const data = res.data;

          reset({
            gift_category_id: data?.gift_category_id
              ? { value: data?.gift_category_id, label: data?.category?.name, name: "gift_category_id" }
              : null,
            occasion_id: data?.occasion_id
              ? { value: data?.occasion_id, label: data?.occasion?.name, name: "occasion_id" }
              : null,
            budget: data?.budget > 0 ? data?.budget : 25000,
            quantity: data?.quantity || "",
            packaging_pref_id: data?.packaging_pref_id || null,
            add_ons: data?.add_ons || "",
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDraft();
  }, []);


  const onSubmit = async (data) => {
    setLoading(true);
    setApiError(null);

    try {
      const payload = {
        draft_id: Cookies.get("draftId") || null,
        gift_category_id: data.gift_category_id?.value || null,
        occasion_id: data.occasion_id?.value || null,
        budget: Number(data.budget),
        quantity: Number(data.quantity),
        packaging_pref_id: data.packaging_pref_id || null,
        add_ons: data.add_ons,
      };

      console.log(data);


      const res = await postBespokeStep2(payload?.draft_id, payload);

      if (res?.success) {
        Cookies.set("draftId", res?.data?.draftId, { expires: 1 });
        handleNext({ draftId: res?.data?.draftId, step2: payload });
      } else if (!res?.success) {
        setApiError(res?.message || "Failed to save. Please try again.");
        setTimeout(() => {
          handleBack()
        }, 3000)
      }
    } catch (err) {
      setApiError(err?.message || "Failed to save. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="step_form_content">
        <Form>
          <Row className="gy-4">

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Gift Type / Category</Form.Label>
                <Controller
                  name="gift_category_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={categoryOptions}
                      placeholder="Select Session"
                    />
                  )}
                />

              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Occasion / Theme</Form.Label>
                <Controller
                  name="occasion_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={occasionOptions}
                      placeholder="Select Session"
                    />
                  )}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Budget Range*</Form.Label>
                {errors.budget && (
                  <div className="invalid-feedback d-block mb-1">
                    {errors.budget.message}
                  </div>
                )}
                <div className="budget_range">
                  <input
                    type="range"
                    min="1000"
                    max="50000"
                    step="500"
                    className="w-100"
                    {...register("budget", {
                      required: "Budget is required",
                    })}
                  />
                  <div className="budget_labels">
                    <span>₹1,000</span>
                    <span className="budget_value">
                      ₹ {Number(budget).toLocaleString("en-IN")}
                    </span>
                    <span>₹50,000</span>
                  </div>
                </div>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Quantity*</Form.Label>
                <Form.Control
                  type="number"
                  min={1}
                  placeholder="Enter Number Of Items Or Hampers"
                  isInvalid={!!errors.quantity}
                  {...register("quantity", {
                    required: "Quantity is required",
                    min: { value: 1, message: "Minimum quantity is 1" },
                    max: { value: 100, message: "Maximum quantity is 100" },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Quantity must be a whole number",
                    },
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.quantity?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Packaging Preference</Form.Label>

                <input type="hidden" {...register("packaging")} />

                <div className="delivery_options">
                  {packagingOptions.map((item) => (
                    <div
                      key={item?.id}
                      className={`delivery_box ${packaging === item?.id ? "active" : ""}`}
                    >
                      <Form.Check
                        type="radio"
                        id={`${item?.id}`}
                        name="packaging"
                        label={item?.name}
                        value={item?.id}
                        checked={packaging === item?.id}
                        onChange={() => setValue("packaging_pref_id", item?.id)}
                      />
                    </div>
                  ))}
                </div>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Add-Ons</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Enter Add Ons"
                  isInvalid={!!errors.add_ons}
                  {...register("add_ons", {
                    validate: (value) => {
                      const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
                      return wordCount <= 1000 || "Maximum 1000 words allowed";
                    },
                  })}
                />
                {errors.add_ons && (
                  <Form.Control.Feedback type="invalid">
                    {errors.add_ons.message}
                  </Form.Control.Feedback>
                )}
                <div className="error_text_holder">
                  <p>
                    <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                    e.g., Flowers, Chocolates, Candles, Cards
                  </p>
                </div>
              </Form.Group>
            </Col>

          </Row>

          {apiError && (
            <div className="alert alert-danger mt-3 py-2" role="alert">
              {apiError}
            </div>
          )}
        </Form>
      </section>

      <div className="btn_holder">
        <Purple_border_btn onClick={handleBack} btnText="Back" />
        <Purple_Btn
          onClick={handleSubmit(onSubmit)}
          btnText={loading ? "Saving..." : "Save & Next"}
          disabled={loading}
        />
      </div>
    </>
  );
}

export default Step_2;